import supabase from '../supabaseClient';

// ── Formulario de contacto público en /informacion — visitante sin sesión ──
export const sbEnviarContacto = async ({ nombre, email, mensaje, campo_extra }) => {
  const { data, error } = await supabase.functions.invoke('enviar-contacto', {
    body: { nombre, email, mensaje, campo_extra },
  });
  if (error) throw new Error('No se pudo enviar el mensaje. Inténtalo de nuevo.');
  return data;
};
